module.exports = __webpack_public_path__ + "media/images/Desktop-Extension 1-4d6e5d2e499ccb21b00fd4a910ef09bc.png";